import NonCriticalError from '@/errors/NonCriticalError.js';

class Required2faError extends NonCriticalError {
}

export default Required2faError;
